import type { PagesProps } from '@graphcommerce/framer-next-pages'
import type { IfConfig, PluginProps } from '@graphcommerce/next-config'
import { KlaviyoActiveOnSiteScript } from '../components/Klaviyo/KlaviyoActiveOnSiteScript'
import { KlaviyoTrackingScript } from '../components/Klaviyo/KlaviyoTrackingScript'

export const component = 'FramerNextPages'
export const exported = '@graphcommerce/framer-next-pages'
export const ifConfig: IfConfig = 'klaviyoPublicKey'

function KlaviyoFramerNextPages(props: PluginProps<PagesProps>) {
  const { Prev, ...rest } = props
  return (
    <>
      <KlaviyoTrackingScript />
      <KlaviyoActiveOnSiteScript />
      <Prev {...rest} />
    </>
  )
}

export const Plugin = KlaviyoFramerNextPages
